const actions = {
  GENERATE_PDF_BEGIN: 'GENERATE_PDF_BEGIN',
  GENERATE_PDF_SUCCESS: 'GENERATE_PDF_SUCCESS',
  GENERATE_PDF_ERROR: 'GENERATE_PDF_ERROR',

  generatePdfBegin: () => ({
    type: actions.GENERATE_PDF_BEGIN,
  }),

  generatePdfSuccess: (data: any) => ({
    type: actions.GENERATE_PDF_SUCCESS,
    data,
  }),

  generatePdfError: (error: any) => ({
    type: actions.GENERATE_PDF_ERROR,
    error,
  }),
};

export default actions;